const getMetaByWidgetType = (widget) => {
  if (widget === "search") {
    return findify.grid.state.meta;
  }
  if (widget === "autocomplete") {
    return findify.autocomplete.state.meta;
  }
  if (widget.includes("findify-rec")) {
    return findify.recommendation.state[widget]?.response?.meta;
  }
  throw new Error(`there is no meta for widget type : ${widget}`);
};

const initProductCardAnalytics = (id, properties) => {
  const meta = getMetaByWidgetType(properties.widget);

  try {
    findify.core.analytics?.sendEvent("click-item", {
      rid: meta.rid,
      item_id: id,
      variant_item_id: properties.selected_variant_id,
    });
  } catch (error) {
    console.log("error", error);
  }
};

const savePosition = (id, page) => {
  const url = window.location.href
  sessionStorage.setItem('product', JSON.stringify({id, url, page}))
}

const initOnProductCardClick = (id, page, properties) => {
  document.querySelector(`.${properties.widget}_${id}`).addEventListener("click", (e) => {
    initProductCardAnalytics(id, properties);
    savePosition(id, page);
  });
};

const cleanActiveSwatches = (productCard) => {
  productCard.querySelectorAll('.findify-color-swatch').forEach((swatch) => 
   swatch.classList.remove('findify-active'));
}

const setProductUrl = (productCard, url) => {
  productCard.querySelectorAll('.findify-product-link').forEach((aTag) =>
    aTag.setAttribute("href", url)
  );
}

/**
 * Sync inventory badge when Findify swatch is clicked
 * @param {HTMLElement} productCard
 * @param {string} variantUrl - URL with variant parameter
 * @param {string|null} defaultVariantId - Default variant to restore on deactivate
 */
const syncFindifyInventoryBadge = (productCard, variantUrl, defaultVariantId) => {
  if (!window.CustomInventoryAPI) return;

  const inventoryEl = productCard.querySelector('.product-inventory--card[data-product-id]');
  if (!inventoryEl) return;

  // Extract variantId from URL
  let variantId = null;
  try {
    const url = new URL(variantUrl, window.location.origin);
    variantId = url.searchParams.get('variant');
  } catch (e) {
    return;
  }

  // Use default variant if deactivating
  if (!variantId && defaultVariantId) {
    variantId = defaultVariantId;
  }

  if (!variantId) return;

  // Get variant metadata from card
  const variantsDataEl = productCard.querySelector('.product-card-variants-data');
  let variantsData = {};
  if (variantsDataEl) {
    try {
      variantsData = JSON.parse(variantsDataEl.textContent);
    } catch (e) {}
  }

  // Update inventory element data
  inventoryEl.dataset.variantId = variantId;
  if (variantsData[variantId]) {
    inventoryEl.dataset.inventoryPolicy = variantsData[variantId].inventoryPolicy || 'deny';
    inventoryEl.dataset.deliveryTime = variantsData[variantId].deliveryTime || '';
    if (typeof variantsData[variantId].available !== 'undefined') {
      inventoryEl.dataset.variantAvailable = variantsData[variantId].available;
    }
  }

  // Set to loading state
  inventoryEl.dataset.inventoryLevel = 'loading';
  const textEl = inventoryEl.querySelector('.js-inventory-notice');
  if (textEl) {
    textEl.textContent = window.InventoryTranslations?.checking || 'Tarkistetaan…';
  }
  const urgencyEl = inventoryEl.querySelector('.js-inventory-urgency');
  if (urgencyEl) {
    urgencyEl.textContent = '';
    urgencyEl.hidden = true;
  }

  // Refresh inventory
  window.CustomInventoryAPI.refreshCardInventory(productCard);
};

const onSwatchClick = (event, product_url, variant_url, variant_image) => {

  const targetedSwatch = event.target;
  const productCard = targetedSwatch.closest('div[id].findify-product-card');
  const swatchImage = productCard.querySelector('.findify-product-swatch-image');

  // Get default variant ID for deactivation (restore original)
  const inventoryEl = productCard.querySelector('.product-inventory--card[data-product-id]');
  const defaultVariantId = inventoryEl ? inventoryEl.dataset.defaultVariantId || inventoryEl.dataset.variantId : null;

  if (targetedSwatch.classList.contains('findify-active')) {
    // Deactivate - restore to default
    cleanActiveSwatches(productCard);
    setProductUrl(productCard, product_url);
    swatchImage.setAttribute('hidden', true);

    // Sync inventory badge back to default variant
    syncFindifyInventoryBadge(productCard, product_url, defaultVariantId);
  }
  else {
    // Activate - show selected variant
    cleanActiveSwatches(productCard);
    targetedSwatch.classList.add('findify-active');

    setProductUrl(productCard, variant_url);
    swatchImage.removeAttribute('hidden');
    // Add width parameter for optimized loading (533px is max card image width)
    const imageUrl = '//cdn.shopify.com/s/files/' + variant_image;
    swatchImage.src = imageUrl.includes('?')
      ? imageUrl + '&width=533'
      : imageUrl + '?width=533';

    // Sync inventory badge to selected variant
    syncFindifyInventoryBadge(productCard, variant_url, null);
  }
}
